const typographyActionExpansion = {
  action: 'Actions ',
  accountable: 'Accountables: ',
  deadline: 'Deadline: ',
  noAccountable: 'No accountable',
  action: "Action: ",
  problem: "Problem: ",
};

export default typographyActionExpansion;
